import { render } from "./CambioProceso.vue?vue&type=template&id=17fbcf1c"
import script from "./CambioProceso.vue?vue&type=script&lang=js"
export * from "./CambioProceso.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__